import { carouselItems } from '@/mocks/homeData';

export default function Carousel() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            深度专题报道，带你全面了解娱乐圈最热门的事件
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden transition-all duration-300 hover:border-primary-200 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/9] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full bg-accent-500/90 text-background-50 text-[11px] font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {item.excerpt}
                </p>
                <div className="mt-3 pt-3 border-t border-background-200/60">
                  <span className="inline-flex items-center gap-1 text-xs text-primary-500 font-medium group-hover:text-primary-600 transition-colors cursor-pointer">
                    阅读全文 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}